<template>
  <div>
    <v-container fluid class="pa-0 pb-8">
      <v-container class="container-custom" v-if="!createNewScholarship">
        <template v-if="!insideDrawer">
          <Breadcrumbs
            :title="$t('modules.scholarships.create.breadcrumbs.title')"
            :description="$t('modules.scholarships.create.breadcrumbs.description')"
          ></Breadcrumbs>
        </template>
        <template>
          <v-row justify="center">
            <v-col class="viewSpaces" sm="12">
              <OutlinedCard
                :title="$t('modules.scholarships.create.sectionData.title')"
                :subtitle="$t('modules.scholarships.create.sectionData.subtitle')"
                :switchValue="newScholarship.status"
                :switchLabel="changeStatuslabel"
                @switchChange="changeStatus()"
                switcher
                class="mb-6"
              >
                <v-row>
                  <v-col sm="6">
                    <v-text-field
                      outlined
                      :error="$v.newScholarship.description.$anyError"
                      :error-messages="descriptionErrors"
                      :label="`${$t('modules.scholarships.create.sectionData.items.name')} *`"
                      v-model.trim="$v.newScholarship.description.$model"
                      @blur="()=>$v.newScholarship.description.$touch()"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3">
                    <v-text-field
                      outlined
                      :error="$v.newScholarship.code.$anyError"
                      :error-messages="codeErrors"
                      :loading="loadingCode"
                      @paste="onPaste"
                      :label="`${$t('modules.scholarships.create.sectionData.items.code')} *`"
                      :value="$v.newScholarship.code.$model"
                      @input="$v.newScholarship.code.$model = $event.toUpperCase()"
                      @blur="()=>{$v.newScholarship.code.$touch(); loadingCode=true; validateCode($v.newScholarship.code.$model)}"
                      required
                      type="text"
                      min="1"
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3">
                    <v-menu
                      ref="menu"
                      v-model="item.menu"
                      :close-on-content-click="false"
                      :return-value.sync="newScholarship.from"
                      transition="scale-transition"
                      offset-y
                      required
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model.trim="$v.newScholarship.from.$model"
                          @blur="()=>$v.newScholarship.from.$touch()"
                          :label="`${$t('modules.scholarships.create.sectionData.items.from')} *`"
                          :error="$v.newScholarship.from.$anyError"
                          :error-messages="fromErrors"
                          append-icon="mdi-calendar"
                          readonly
                          required
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title color="primary" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6">
                    <v-select
                      outlined
                      multiple
                      :label="`${$t('modules.scholarships.create.sectionData.items.relation')} *`"
                      v-model="selectedBillingProducts"
                      @blur="selectedBillingProductsTouch"
                      :items="billingProduct"
                      :error-messages="errorMesagesSelected ? $t('modules.scholarships.create.sectionData.error.selectedBillingProducts'):''"
                      item-text="name"
                      return-object
                    ></v-select>
                  </v-col>
                  <v-col cols="3" justify="center" align="center">
                    <v-switch
                      class="mt-1"
                      v-model="withAverage"
                      color="primary"
                      :label="`Aplica a promedio`"
                    ></v-switch>
                  </v-col>
                </v-row>
                <MultipleFormGroupCustom
                  :selectedBillingProducts="selectedBillingProducts"
                  :discountType="discountType"
                  :withAverage="withAverage"
                  @errorMultipleForm="updateErrorStatus($event)"
                ></MultipleFormGroupCustom>
                <v-divider v-if="selectedBillingProducts.length === 0" class="my-4"></v-divider>
                <v-row>
                  <v-col sm="12">
                    <v-card-title
                      class="title font-weight-bold ma-0 px-0 pt-2"
                    >{{ $t('modules.scholarships.create.sectionRenewal.title') }}</v-card-title>
                    <v-card-text
                      class="body-2 pa-0 ma-0"
                    >{{ $t('modules.scholarships.create.sectionRenewal.subtitle') }}</v-card-text>
                    <v-switch
                      v-model="newScholarship.renew"
                      color="primary"
                      :label="$t('modules.scholarships.create.sectionRenewal.items.renewalCheck')"
                    ></v-switch>
                  </v-col>
                </v-row>
              </OutlinedCard>
              <OutlinedCard
                :title="$t('modules.scholarships.create.sectionDocumentation.title')"
                :subtitle="$t('modules.scholarships.create.sectionDocumentation.subtitle')"
                class="mb-6"
              >
                <TransferList
                  :avatar="false"
                  :loading="loadingSearchDocs"
                  :firstListTitle="$t('modules.scholarships.create.sectionDocumentation.transferList.firstTitle')"
                  :secondListTitle="$t('modules.scholarships.create.sectionDocumentation.transferList.secondTitle')"
                  :availableItems.sync="docs"
                  :added-items.sync="docsAdded"
                  areEquals="id"
                  @searchItemLeftOnBackend="searchDocs"
                  @searchItemRightOnBackend="searchDocsAdded"
                ></TransferList>
                <v-alert
                  text
                  type="warning"
                  class="mt-4"
                  v-if="docsAdded.length===0"
                >{{ $t('modules.scholarships.create.warning.no_selected_warning') }}</v-alert>
              </OutlinedCard>
              <OutlinedCard
                :title="$t('modules.scholarships.create.sectionRestriction.title')"
                class="mb-6"
              >
                <v-radio-group v-model="limited" class="no-message ma-0">
                  <v-radio
                    :label="$t('modules.scholarships.create.sectionRestriction.items.radioFirst')"
                    color="primary"
                    :value="0"
                  ></v-radio>
                  <div class="d-flex">
                    <v-radio
                      :label="$t('modules.scholarships.create.sectionRestriction.items.radioSecond')"
                      color="primary"
                      :value="1"
                    ></v-radio>
                    <v-text-field
                      :error-messages="($v.limit.$invalid && $v.limit.$dirty) ? $t('modules.scholarships.create.errors.limit') : ''"
                      outlined
                      v-model.number="$v.limit.$model"
                      type="text"
                      @paste="onPaste"
                      @keypress="$validateIntegerInputNumber($event, $v.limit.$model, null, 6)"
                      placeholder="0"
                      @blur="$v.limit.$touch()"
                      :disabled="!limited"
                    ></v-text-field>
                  </div>
                </v-radio-group>
              </OutlinedCard>
              <div class="d-flex justify-end">
                <Button
                  white
                  :text="$t('actions.cancel')"
                  @clicked="$router.replace('/scholarships')"
                  @end="resetButtonValues()"
                  class="mr-4"
                ></Button>

                <Button
                  :loading="createButton.loading"
                  :success="createButton.success"
                  :error="createButton.error"
                  :text="$t('actions.create')"
                  :successText="$t('actions.created')"
                  :errorText="'Error'"
                  :disabled="!canCreate || !canCreateScholarship"
                  @end="resetButtonValues()"
                  @clicked="verifyScholarship"
                ></Button>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>
      <SuccessMessage
        v-else
        :title="successMessage.title"
        :type="successMessage.type"
        :actionPrimary="successMessage.actionPrimary"
        :actionSecondary="successMessage.actionSecondary"
      />
    </v-container>
  </div>
</template>

<style lang="sass">
  .containerPadding
    padding-left: 34px
    padding-right: 34px
</style>

<script>
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import MultipleFormGroupCustom from '../Components/MultipleFormGroupCustom/MultipleFormGroupCustom';
import Button from '@/components/Button/Button';
import { required, minValue, decimal, requiredIf } from 'vuelidate/lib/validators';
import TransferList from '@/components/TransferList/TransferList';
import { $products, $documentations, $scholarships } from '../services';
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
import { mapGetters } from 'vuex';

export default {
  name: 'ScholarshipsCreate',
  components: {
    OutlinedCard,
    Breadcrumbs,
    TransferList,
    Button,
    MultipleFormGroupCustom,
    SuccessMessage
  },
  data () {
    return {
      paginationLimit: 150,
      loadingSearchDocs: false,
      errorMesagesSelected: false,
      radioValue1: undefined,
      radioValue2: undefined,
      errorChild: false,
      insideDrawer: false,
      limit: null,
      limited: 0,
      item: {
        menu: false,
        date: '',
        relation: '',
        percentage: '',
        amount: ''
      },
      groups: [
        {
          label: null,
          billingProduct: {
            id: null
          },
          average: null,
          percentage: null,
          amount: null
        }
      ],
      withAverage: true,
      createNewScholarship: null,
      successMessage: {
        title: null,
        actionPrimary: null
      },
      finishButton: {
        loading: false,
        success: false,
        error: false,
        text: this.$t('actions.create'),
        successText: this.$t('actions.created'),
        errorText: 'error'
      },
      loadingCode: false,
      validationErrorCode: false,
      discountType: [this.$t('modules.scholarships.create.discountType.percentege'), this.$t('modules.scholarships.create.discountType.amount')],
      firstTimeChange: true,
      docs: [],
      docsAdded: [],
      discountValue: this.$t('modules.scholarships.create.discountType.percentege'),
      discountAux: {},
      date: '',
      billingProduct: [],
      selectedBillingProducts: [],
      selectedProducts: [],
      newScholarship: {
        description: null,
        code: null,
        from: null,
        status: true,
        renew: true,
        limit: 1,
        scholarshipDocs: [],
        scholarshipProduct: []
      },
      createButton: {
        loading: false,
        success: false,
        error: false
      }
    };
  },
  async mounted () {
    this.getScholarshipsDocs();
    this.getBillingProducts();
  },
  computed: {
    canCreate() {
      return this.$permissions.portaladministrativo.prices.scholarships.CREATE
    },
    ...mapGetters({userId: 'commons/getUserID',}),
    canCreateScholarship () {
      let validationCount = 0;
      Object.keys(this.newScholarship).forEach(key => {
        if (
          key !== 'limit' && (
            this.newScholarship[key] === null ||
            this.newScholarship[key] === '' ||
            this.docsAdded.length === 0 ||
            this.selectedBillingProducts.length === 0 ||
            this.errorChild === true ||
            this.validationErrorCode === true ||
            this.loadingCode === true)
        ) {
          validationCount++;
        }
        if (this.limit === null && this.limited === 1) {
          validationCount++;
        }
      });
      if (this.$v.limit.$anyError) {
        validationCount++;
      }
      if (validationCount > 0) {
        return false;
      } else {
        return true;
      }
    },
    changeStatuslabel () {
      return this.newScholarship.status
        ? this.$t('modules.scholarships.create.sectionData.labelEnable')
        : this.$t('modules.scholarships.create.sectionData.labelDisable');
    },
    descriptionErrors () {
      const errors = [];
      if (!this.$v.newScholarship.description.$anyError) return errors;
      if (!this.$v.newScholarship.description.required)
        errors.push(
          this.$t('modules.scholarships.create.validations.descriptionRequired')
        );
      return errors;
    },
    codeErrors () {
      const errors = [];
      if (this.validationErrorCode) {
        errors.push(
          this.$t('modules.scholarships.create.validations.codeExist')
        );
      }
      if (!this.$v.newScholarship.code.$anyError) return errors;
      if (!this.$v.newScholarship.code.required)
        errors.push(
          this.$t('modules.scholarships.create.validations.codeRequired')
        );

      return errors;
    },
    fromErrors () {
      const errors = [];
      if (!this.$v.newScholarship.from.$anyError) return errors;
      if (!this.$v.newScholarship.from.required)
        errors.push(
          this.$t('modules.scholarships.create.validations.fromRequired')
        );
      return errors;
    },
  },
  methods: {
    updateErrorStatus ($event) {
      this.errorChild = $event;
    },
    selectedBillingProductsTouch () {
      if (!this.selectedBillingProducts.length) {
        this.errorMesagesSelected = true
      } else {
        this.errorMesagesSelected = false
      }
    },
    async validateCode (value) {
      if (value) {
        this.loadingCode = true;
        const response = await $scholarships.find('exists', null, {
          params: {
            code: value
          }
        });
        if (response.data.exists) {
          this.validationErrorCode = true;
        } else {
          this.validationErrorCode = false;
        }
      }
      this.loadingCode = false;
    },
    updateDiscountValue () {
      this.$v.groups.$reset();
    },
    onPaste () {
      event.preventDefault();
    },
    onWithoutRestrictionClick () {
      this.limit = 0;
      this.newScholarship.limit = 0;
    },
    onWithRestrictionClick () {
      this.limit = 1;
      this.newScholarship.limit = 1;
    },
    changeStatus () {
      this.newScholarship.status = !this.newScholarship.status;
    },
    // async getDiscountType() {
    //   const fetchedDiscountTypes = await $types.find(null, null, { params: { type: "DISCOUNT_TYPE"}})
    //   this.discountType = fetchedDiscountTypes.data;
    //   this.discountType = this.modalityTypes.map(type => {
    //     return {
    //       id: type.value,
    //       name: type.meaning
    //     };
    //   });
    // },
    async getBillingProducts () {
      this.billingProduct = await $products.find();
      this.billingProduct = this.billingProduct.data.content.map(product => {
        return {
          id: product.id,
          name: product.name,
          discountValue: this.$t('modules.scholarships.create.discountType.percentege'),
          details: [
            {
              billingProduct: {
                id: product.id
              },
              average: null,
              percentage: null,
              amount: null,
              error: true
            }
          ]
        };
      });
    },
    searchDocs (event) {
      this.getScholarshipsDocs(event);
    },
    searchDocsAdded (event) {
      this.docsAdded = event
    },
    async getScholarshipsDocs (doc) {
      this.loadingSearchDocs = true
      let documentations = [];
      if (doc) {
        documentations = await $documentations.find(null, null, {
          params: { name: doc, length: this.paginationLimit }
        });
      } else {
        documentations = await $documentations.find(null, null, {
          params: { length: this.paginationLimit }
        });
      }
      if (documentations.data && documentations.data.length) {
        documentations = documentations.data.map(item => {
          return {
            id: item.id,
            name: item.name
          };
        });
        this.docs = documentations;
      }
      this.loadingSearchDocs = false
    },
    async verifyScholarship () {
      if (!this.newScholarship.status) {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.scholarships.create.warning_status.title'),
          content: null,
          actionPrimary: {
            text: this.$t(
              'modules.scholarships.create.warning_status.actions.primary_text'
            ),
            callback: () => {
              this.createScholarship();
            }
          },
          actionSecondary: {
            text: this.$t(
              'modules.scholarships.create.warning_status.actions.secondary_text'
            ),
            callback () { }
          },
          icon: { color: 'warning', name: 'mdi-eye-off-outline' },
          color: 'primary'
        });
        this.createButton.loading = false;
      } else {
        this.createScholarship();
      }
    },
    async createScholarship () {
      if (!this.canCreate) return false
      this.createButton.loading = true;
      this.newScholarship.scholarshipProduct = []
      this.selectedBillingProducts.map(item => {
        const itemReturn = item.details.map(item2 => {
          const itemReturn2 = {
            billingProduct: {
              id: null,
            },
            average: Number(item2.average),
            percentage:
              item.discountValue === this.$t('modules.scholarships.create.discountType.percentege') || item.discountValue === this.$t('modules.scholarships.create.discountType.percentege_lowercase')
                ? Number(item2.percentage ? item2.percentage : 0)
                : null,
            amount:
              item.discountValue === this.$t('modules.scholarships.create.discountType.amount') || item.discountValue === this.$t('modules.scholarships.create.discountType.amount_lowercase')
                ? Number(item2.amount ? item2.amount : 0)
                : null
          };
          itemReturn2.billingProduct.id = item.id;

          this.newScholarship.scholarshipProduct.push(itemReturn2);
          return itemReturn2;
        });
        item.details = itemReturn;

        return item.details;
      });

      this.newScholarship.scholarshipDocs = this.docsAdded.map(item => {
        return {
          documentation: {
            id: item.id
          },
          fileName: null,
          from: null,
          
        };
      });
      this.newScholarship.limit = (this.limited) ? this.limit : null
      try {
        this.newScholarship.userId = this.userId
        await $scholarships.create(this.newScholarship);
        this.successMessage.type = 'success';
        this.successMessage.title = `${
          this.newScholarship.description
          } ${this.$t(
            'modules.scholarships.create.success_message.description'
          )}`;
        if (!this.insideDrawer) {
          this.successMessage.actionPrimary = {
            text: this.$t(
              'modules.scholarships.create.success_message.actions.primary_text'
            ),
            callback: () => {
              this.$router.push('/scholarships');
            }
          };
          this.successMessage.actionSecondary = {
            text: this.$t('modules.scholarships.create.success_message.actions.secondary_text'),
            callback: () => {
              this.createNewScholarship = false            }
          };
        } else {
          this.successMessage.actionPrimary = {
            text: this.$t(
              'modules.scholarships.create.success_message.actions.primary_text'
            ),
            callback: () => {
              this.$emit('closeDrawer');
            }
          };
          this.successMessage.actionSecondary = {
            text: this.$t('modules.scholarships.create.success_message.actions.secondary_text'),
            callback: () => {
              this.createNewScholarship = false
            }          };
        }
        this.createNewScholarship = true;
        this.clearData()
      } catch (error) {
        // this.successMessage.type = "error";
        // this.successMessage.title = this.$t(
        //   "modules.scholarships.create.error_message.title"
        // );
        // this.successMessage.actionSecondary = null;
        // if (!this.insideDrawer) {
        // this.successMessage.type = 'error';
        // this.successMessage.title = this.$t("modules.scholarships.create.error_message.title");
        // this.successMessage.actionSecondary = null;
        // this.createNewScholarship = true;
        // this.createButton.loading = false;
        // this.createButton.error = true;
        this.createButton.error = true;

        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.scholarships.create.error_message.title', {
            action: 'crear'
          }),
          content: error.message,
          actionPrimary: {
            text: this.$t('modules.scholarships.create.errors.popup.btnPrimary'),
            callback () { }
          },
          actionSecondary: null,
          icon: { color: 'error', name: 'mdi-cancel' },
          color: 'primary'
        });

        // } else {
        //   this.successMessage.actionPrimary = {
        //     text: this.$t(
        //       "modules.scholarships.create.success_message.actions.primary_text"
        //     ),
        //     callback: () => {
        //       this.$emit("closeDrawer");
        //     }
        //   };
        // }
      } finally {
        this.createButton.loading = false;
        this.createButton.error = true;
      }
    },
    resetButtonValues () {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
    clearData () {
      this.resetButtonValues();
      this.$v.$reset();
      this.limit = 1
      this.newScholarship.description = null
      this.newScholarship.code = null
      this.newScholarship.from = null
      this.newScholarship.status = true
      this.newScholarship.renew = true
      this.newScholarship.limit = 1
      this.newScholarship.scholarshipDocs = []
      this.newScholarship.scholarshipProduct = []
      // this.getBillingProducts()
      this.selectedBillingProducts = []
      this.docsAdded = []
      this.getScholarshipsDocs()
    }
  },
  validations: {
    newScholarship: {
      code: {
        required
      },
      description: {
        required
      },
      from: {
        required
      },
      status: {
        required
      },
      renew: {
        required
      },
      limit: {
        required
      },
      scholarshipDocs: {
        required
      },
      scholarshipProduct: {
        required
      }
    },
    limit: {
      decimal,
      minValue: minValue(0),
      required: requiredIf(function () {
        return this.limited
      })
    }
  }
};
</script>
